module.exports = __webpack_public_path__ + "img/09.935b6632.jpg";